<template>
    <popup class="pre-view-popup" fullscreen :active="active" :blocked="true" @close="cancelHandler">
        <template #header>
            <div class="close-icon">
                <vs-button
                    type="flat"
                    icon-pack="feather"
                    icon="icon-x"
                    @click="cancelHandler()"
                ></vs-button>
            </div>
        </template>
        <template #body>
            <div v-if="data" class="p-10">
                <div class="flex head mb-10">
                    <span class="title-text">{{ data.desired_position }}</span>
                    <span class="wage px-4 py-1">{{
                        data.desired_salary
                    }}</span>
                </div>
                <vs-row class="flex mb-10">
                    <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
                        <img
                            :src="data.avatar"
                            alt=""
                            style="object-fit: cover"
                            width="160"
                            height="160"
                        />
                    </vs-col>
                    <vs-col vs-lg="8" vs-sm="8" vs-xs="12" class="flex-between">
                        <div class="column-flex">
                            <span class="name"
                                >{{ userName }}</span
                            >
                            <span>{{ setSheldule(data.schedule) }}</span>
                        </div>
                        <div class="flex">
                            <div class="infos-column">
                                <div class="flex ">
                                     <span class="main-info">{{ $t("age") }}:</span>
                                      <span class="ml-2">{{ data.student.age }}</span>
                                </div>
                                <div class="flex ">
                                     <span class="main-info">{{ $t("city") }}:</span>
                                      <span class="ml-2">{{ data.student.birth_place }}</span>
                                </div>
                                <div class="flex ">
                                     <span class="main-info"
                                    >{{ $t("citizenship") }}:</span
                                >
                                 <span class="ml-2">{{ data.student.citizenship }}</span>
                                </div>
                                <div class="flex ">
                                   <span class="main-info"
                                    >{{ $t("edication") }}:</span
                                >    <span class="ml-2">{{ data.student.education }}</span>
                                </div>
                                <div class="flex ">
                                   <span class="main-info"
                                    >{{ $t("family_status") }}:</span
                                > <span class="ml-2">{{ data.student.marital_status }}</span>
                                </div>


                            </div>

                        </div>
                    </vs-col>
                </vs-row>
                <div v-if="data.job_experience.length" class="mb-10">
                    <span class="subtitle-text flex-start mb-5">{{ $t("job_exp") }}</span>
                    <div class="job_exp">
                    <div
                        v-for="(item, index) in data.job_experience"
                        class="flex justify-between mt-4"
                        style="margin-right: 10px; flex-direction: column; max-width: 750px; word-wrap: break-word;"
                        :key="index"
                    >

                        <div>
                            <span>{{ $moment(item.begin).format('DD.MM.YYYY') + `-` +
                                   endDate(item) }}</span>
                        </div>
                        <div class="flex-between">
                            <div class="column-flex mb-5">
                                <span v-if="item.position" class="main-info ">{{
                                    item.position
                                }}</span>
                                <span v-if="item.company_name" >{{ item.company_name }}</span>
                            </div>
                            <div v-if="item.responsibility" class="column-flex">
                                <span class="main-info ">{{
                                    $t("responsibility")
                                }}</span>
                                <span>{{ item.responsibility }}</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div v-if="data.pro_skills || data.other_skills" class="mb-10">
                    <span class="subtitle-text">{{
                        $t("knowleges_adn_skills")
                    }}</span>
                    <div v-if="data.pro_skills" class="column-flex mb-5">
                        <span class="main-info">{{ $t("pro_skills") }}</span>
                        <span>{{ data.pro_skills }}</span>
                    </div>
                    <div v-if="data.other_skills" class="column-flex">
                        <span class="main-info">{{ $t("other_skills") }}</span>
                        <span>{{ data.other_skills }}</span>
                    </div>
                </div>
                <div v-if="data.courses.length" class="column-flex mb-10">
                    <span class="subtitle-text">{{
                        $t("additional_courses")
                    }}</span>

                    <span
                        v-for="(item, index) in data.courses"
                        :key="index"
                        >{{ item.name }} - {{item.place}}</span
                    >
                </div>
            </div>
        </template>
        <template #footer>
            <div class="btn flex justify-end w-full p-3">
                <!-- <vs-button type="border" disabled>
                    <span>{{ $t("edit") }}</span>
                </vs-button> -->
                <div class="px-1"></div>
                <vs-button @click="cancelHandler()">
                    <span>{{ $t("close") }}</span>
                </vs-button>
            </div>
        </template>
    </popup>
</template>

<script>
import Popup from "./Popup.vue";
export default {
    components: { Popup },
    props: {
        active: {
            type: Boolean,
        },
        title: {
            type: String,
        },
        data: {
            type: Object,
        },
        userName:{}
    },
    data() {
        return {
            selectedImage: {
                name: "",
            },
        };
    },
    computed: {

    },
    methods: {
        endDate(item){
            return item.end == null || item.end === "" ? this.$t('until_now' ) :
                this.$moment(item.end).format('DD.MM.YYYY')
        },
        setSheldule(item) {
            if (item === "2") {
                let str = this.$t("full_time");
                return str;
            } else if (item === "1") {
                let str = this.$t("part_time");
                return str;
            }
        },
        declOfNum(n, text_forms) {
            n = Math.abs(n) % 100; var n1 = n % 10;
            if (n > 10 && n < 20) { return text_forms[2]; }
            if (n1 > 1 && n1 < 5) { return text_forms[1]; }
            if (n1 === 1) { return text_forms[0]; }
            return text_forms[2];
        },
        cancelHandler() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.infos-column {
    display: flex;
    flex-direction: column;
}
.vs-popup {
    width: 800px !important;
}
.subtitle-text {
    font-size: large;
    font-weight: 500;
    color: #545da7;
}
.flex-between {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.main-info {
    font-weight: bold;
    font-size: 600;
}
.column-flex {
    display: flex;
    flex-direction: column;
}
.name {
    font-size: large;
    font-weight: bold;
}
.head {
    align-items: center;
    justify-content: space-between;
}
.title-text {
    font-size: large;
    font-weight: 600;
}
.wage {
    border-radius: 30px;
    background-color: #2dcd7a;
    color: white;
    font-weight: bold;
}
.close-icon {
    display: flex;
    justify-content: flex-end;
}
.imageBox {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}
.imageBox-active {
    border-radius: 5px;
    border: solid 1px #545da7;
    background-color: #f2f1f2;
}
.job_exp {
    display: grid;
    grid-gap: 40px;
}
</style>
